import React, { FC } from 'react'
import imageResize from 'project/image-proxy-web'
import { Format } from 'common/utils/format'

type TargetMarketCardType = {}

const points = [
  {
    content: `Our partner rate card offers wholesale discounts based on volume, ranging from ${Format.moneyShort(
      10000,
    )} to ${Format.moneyShort(
      7000,
    )} per end client. You are free to set your own margin and can offer this service alongside your existing products/services in any way that best suits your business model. Our current retail price for this service is ${Format.moneyShort(
      25900,
    )} per annum.`,
    title: `Manage your client's mail from ${Format.moneyShort(
      7000,
    )} per year.`,
  },
  {
    content:
      'Recharge to clients to drive incremental revenue potential. A base of 10k users could generate up to an additional £400,000k per year*.',
    title: 'Additional revenue stream.',
  },
  {
    content:
      'We partner with a variety of accounting firms and financial institutions and have served over 100,000 customers to date.',
    title: 'Trusted partnerships.',
  },
]

const TargetMarketCard: FC<TargetMarketCardType> = () => {
  return (
    <>
      <h1 className='fw-semibold mb-6'>
        Registered office address and mail handling – zero up-front cost.
      </h1>

      <div className='d-flex flex-column text-body flex-lg-row'>
        <div className='d-flex flex-column gap-md-8 gap-5'>
          {points.map((v) => (
            <h4 key={v.title} className='fw-normal fs-fluid-24-32'>
              <span className='text-bold'>{v.title}</span>{' '}
              <span className='fw-semibold color-grey5'>{v.content}</span>
            </h4>
          ))}

          <div className='color-grey5'>
            *Based on real client numbers, taking revenue from internal markup
            into account and conversion to 10,000 customers signing up to the
            service.
          </div>
        </div>
      </div>
    </>
  )
}

export default TargetMarketCard
